import styled from '@emotion/styled'

export const StyledBodyContainer = styled.section`
  button {
    &.formButton {
      float: right;
    }
  }
`
